import { images } from '@/asset';
import { Card, IndexTable, Pagination, SkeletonBodyText } from '@shopify/polaris';
import { BulkAction } from '@shopify/polaris/build/ts/src/components/BulkActions';
import { IndexTableHeading } from '@shopify/polaris/build/ts/src/components/IndexTable';
import { MenuGroupDescriptor, NonEmptyArray } from '@shopify/polaris/build/ts/src/types';
import { IndexProviderProps } from '@shopify/polaris/build/ts/src/utilities/index-provider';
import BoldText from '../BoldText';
import { BaseTableStyled } from './styled';

interface IProps {
  itemCount: number;
  headings: NonEmptyArray<IndexTableHeading>;
  isLoading: boolean;
  isFetching?: boolean;
  page?: number;
  perPage?: number;
  onChangePage?: (value: number) => void;
  rowMarkup?: (JSX.Element | null)[];
  totalOfAllItems?: number;
  totalPages?: number;
  style?: React.CSSProperties;
  emptyState?: React.ReactNode;
  selectable?: boolean;
  selectedResources?: string[];
  allResourcesSelected?: boolean;
  promotedBulkActions?: (BulkAction | MenuGroupDescriptor)[];
  onSelectionChange?: IndexProviderProps['onSelectionChange'];
}

const BaseTable = ({
  headings,
  isLoading,
  itemCount,
  rowMarkup,
  onChangePage,
  page,
  perPage,
  totalOfAllItems,
  isFetching,
  totalPages,
  style,
  emptyState,
  selectable = false,
  selectedResources,
  allResourcesSelected,
  onSelectionChange,
  promotedBulkActions,
}: IProps) => {
  const PERPAGE = perPage ?? 10;
  return (
    <BaseTableStyled style={style}>
      {isLoading ? (
        <Card>
          <SkeletonBodyText lines={8} />
        </Card>
      ) : (
        <>
          <IndexTable
            emptyState={
              emptyState ? (
                emptyState
              ) : (
                <div className="d-flex flex-center justify-center f-wrap">
                  <img src={images.emptyState} alt="No data" />
                  <div className="w-full text-center">
                    <BoldText>No data to display</BoldText>
                  </div>
                </div>
              )
            }
            selectable={selectable}
            selectedItemsCount={allResourcesSelected ? 'All' : selectedResources?.length}
            onSelectionChange={onSelectionChange}
            promotedBulkActions={promotedBulkActions}
            itemCount={itemCount}
            headings={headings}
          >
            {rowMarkup}
          </IndexTable>
          {page !== undefined && totalPages && totalOfAllItems && totalOfAllItems > PERPAGE ? (
            <div className="py-8 paginate">
              <Pagination
                label={
                  itemCount
                    ? `Showing ${(page - 1) * PERPAGE + 1} to ${
                        PERPAGE + (page - 1) * PERPAGE < totalOfAllItems ? PERPAGE + (page - 1) * PERPAGE : totalOfAllItems
                      } of ${totalOfAllItems} items`
                    : null
                }
                hasPrevious={!isFetching && page > 1}
                onPrevious={() => {
                  onChangePage?.(page - 1);
                }}
                hasNext={!isFetching && page < totalPages}
                onNext={() => {
                  onChangePage?.(page + 1);
                }}
              />
            </div>
          ) : null}
        </>
      )}
    </BaseTableStyled>
  );
};

export default BaseTable;
